import React from 'react';
var FOCUSABLE_ELEMENTS = ['a[href]', 'area[href]', 'input:not([disabled]):not([type="hidden"]):not([aria-hidden])', 'select:not([disabled]):not([aria-hidden])', 'textarea:not([disabled]):not([aria-hidden])', 'button:not([disabled]):not([aria-hidden])', 'iframe', 'object', 'embed', '[contenteditable]', '[tabindex]:not([tabindex^="-"])'];

var getFocusableElements = function getFocusableElements(containerRef) {
  var elements = containerRef.current.querySelectorAll(FOCUSABLE_ELEMENTS);

  if (elements && elements.length > 0) {
    return {
      elements: elements,
      first: elements[0],
      last: elements[elements.length - 1]
    };
  }

  return {
    elements: [],
    first: null,
    last: null
  };
};

var focusFirstElement = function focusFirstElement(containerRef) {
  var first = getFocusableElements(containerRef).first;

  if (first) {
    first.focus();
  }
};

export var useHideBodyOverflow = function useHideBodyOverflow(hide) {
  React.useLayoutEffect(function () {
    if (hide) {
      document.body.style.overflow = 'hidden';
    }

    return function () {
      document.body.style.overflow = '';
    };
  }, [hide]);
};
export var useFirstElementFocus = function useFirstElementFocus(_a) {
  var shouldFocus = _a.shouldFocus,
      containerRef = _a.containerRef;
  React.useEffect(function () {
    if (shouldFocus) {
      focusFirstElement(containerRef);
    }
  }, [shouldFocus, containerRef]);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Modal/utils.js
// module id = 1170
// module chunks = 0